import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteCargoCorporateCredit } from '../../../../actions/cargo/CargoCorporateCredit';

const CargoCorporateCreditDeleteButton = ({
  dispatchDeleteCargoCorporateCredit,
  cargoCorporateCreditId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () =>
    dispatchDeleteCargoCorporateCredit({ cargoCorporateCreditId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

CargoCorporateCreditDeleteButton.propTypes = {
  dispatchDeleteCargoCorporateCredit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  cargoCorporateCreditId: PropTypes.number.isRequired,
};

CargoCorporateCreditDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteCargoCorporateCredit: deleteCargoCorporateCredit,
};

export default connect(
  null,
  mapDispatchToProps,
)(CargoCorporateCreditDeleteButton);
